'use client';

import * as React from 'react';
import NiceModal from '@ebay/nice-modal-react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

import { AnalyticsProvider } from '@workspace/analytics/hooks/use-analytics';
import { MonitoringProvider } from '@workspace/monitoring/hooks/use-monitoring';
import { TooltipProvider } from '@workspace/ui/components/tooltip';
import { ThemeProvider } from '@workspace/ui/hooks/use-theme';
import { FrigadeProvider } from '@workspace/ui/components/frigade-provider';

import { env } from '~/env';

interface ProvidersProps {
  children: React.ReactNode;
  user?: {
    id: string;
  } | null;
}

export function Providers({
  children,
  user
}: ProvidersProps): React.JSX.Element {
  return (
    <MonitoringProvider>
      <AnalyticsProvider>
        <NuqsAdapter>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            <TooltipProvider>
              <FrigadeProvider
                apiKey={env.NEXT_PUBLIC_FRIGADE_API_KEY}
                userId={user?.id}
              >
                <NiceModal.Provider>{children}</NiceModal.Provider>
              </FrigadeProvider>
            </TooltipProvider>
          </ThemeProvider>
        </NuqsAdapter>
      </AnalyticsProvider>
    </MonitoringProvider>
  );
}
